"use client";

import { useAppStore } from "@/lib/store";

export default function ActiveFyBadge() {
  const fy = useAppStore((s) => s.activeFY);
  if (!fy?.label) return null;
  return (
    <span className="hidden xl:inline-flex items-center rounded-md border border-gray-800 bg-gray-900/80 px-2 py-0.5 text-[10px] font-medium text-gray-400">
      FY {fy.label}
    </span>
  );
}
